// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__HFqOe","rightAdornment":"Header_rightAdornment__uwbW4"};